import "core-js/modules/es6.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getBaseMenuTree, getMenuAuthority, addMenuAuthority } from '@/api/menu';
export default {
  name: 'Menus',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      menuTreeData: [],
      menuTreeIds: [],
      needConfirm: false,
      menuDefaultProps: {
        children: 'children',
        label: function label(data) {
          return data.meta.title;
        }
      }
    };
  },
  methods: {
    nodeChange: function nodeChange() {
      this.needConfirm = true;
    },
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.relation();
    },
    // 关联树 确认方法
    relation: function () {
      var _relation = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var checkArr, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              checkArr = this.$refs.menuTree.getCheckedNodes(false, true);
              _context.next = 1;
              return addMenuAuthority({
                menus: checkArr,
                authorityId: this.row.authorityId
              });
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '菜单设置成功!'
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function relation() {
        return _relation.apply(this, arguments);
      }
      return relation;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res, res1, menus, arr;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return getBaseMenuTree();
          case 1:
            res = _context2.sent;
            this.menuTreeData = res.data.menus;
            _context2.next = 2;
            return getMenuAuthority({
              authorityId: this.row.authorityId
            });
          case 2:
            res1 = _context2.sent;
            menus = res1.data.menus;
            arr = [];
            menus.map(function (item) {
              // 防止直接选中父级造成全选
              if (!menus.some(function (same) {
                return same.parentId === item.menuId;
              })) {
                arr.push(Number(item.menuId));
              }
            });
            this.menuTreeIds = arr;
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};